import React from "react";
import { Box, Flex } from "@chakra-ui/react";
import Sidebar from "../../Components/Sidebar";
import Navbar from "../../Components/Navbar";
import CreditDetails from "./CreditDetails";


const Credits = () => {
return (
    <Flex>
      <Sidebar />
      <Box flex="1" p="4">
        <Navbar />
        <CreditDetails />
      </Box>
    </Flex>
  );
};

export default Credits;
